<template>
  <v-dialog v-model="isVisible" width="400" >
    <v-card>
      <v-card-title> Error </v-card-title>
      <v-card-text> {{ errorMessage }} </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog" > 確認 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      closeDialog: 'error/closeErrorDialog',
    }),
  },
  computed: {
    ...mapState({
      isVisible: (state) => state.error.isVisible,
      errorMessage: (state) => state.error.message,
    }),
  },
};
</script>
